//import React from 'react'
import { Container } from "react-bootstrap";
import { Outlet } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import useListenMessages from "./useListenMessages";

import Footer from "./components/Footer";

import bgImage from "./assets/zpotterGymBG.jpg";
import { useEffect, useState } from "react";
import HeaderLeft from "./components/HeaderLeft";

const App = () => {
  // ENABLE THIS CODE FOR AUTO LOGOFF
  const { userInfo } = useSelector((state) => state.auth);

  const [mobileScreen, setMobileScreen] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setMobileScreen(window.innerWidth < 600);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [expandMenu, setExpandMenu] = useState(true);

  useListenMessages();

  return (
    <>
      <ToastContainer position="top-center" autoClose="3000" />
      {mobileScreen || !userInfo ? (
        <></>
      ) : (
        <HeaderLeft leftMenuOpen={expandMenu} setExpandMenu={setExpandMenu} />
      )}
      <main
        className={`py-3 buttonTeal`}
        style={{
          height: "100vh",
          backgroundAttachment: "fixed",
          overflow: "scroll",
          // backgroundColor: "#d1e7e4",
          // backgroundImage: `url(${bgImage})`, // Corrected: Use backticks and template literal to reference the variable
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          marginBottom: "3rem",
          border: "0.7px solid grey",
          // borderRadius: "10px",
          padding: "0.5rem",
        }}
      >
        <Container
        // style={{
        //   // borderLeft: "1px solid green",
        //   // borderRight: "1px solid green",
        //   border: "0.1px solid grey",
        //   borderRadius: "10px",
        //   padding: "0.5rem",
        // }}
        >
          <Outlet />
        </Container>
      </main>

      {!mobileScreen && <Footer />}
    </>
  );
};

export default App;
